import { sendPhotonEvent } from './utils/photon/client';
import './PostGameButtons.scss';


export const PostGameButtons = ({ handlers }) => {
  const { rematchRequest, backToLobby } = handlers;

  const handleRematch = () => {
    sendPhotonEvent(4, { rematch: true });
    rematchRequest();
  };

  const handleBackToLobby = () => {
    sendPhotonEvent(4, { rematch: false })
    backToLobby();
  };

  return (
    <div id="post-game-buttons">
      <button
        id="rematch"
        onClick={handleRematch}
      >
        REMATCH
      </button>
      <button
        id="lobby"
        onClick={handleBackToLobby}
      >
        LOBBY
      </button>
    </div>
  )
};
